import type { BlogPost } from '../types/content';
import { IMAGES } from './images';

export const blogPosts: BlogPost[] = [
  {
    slug: 'shooting-vs-defending',
    title: 'Learning to Shoot vs. Learning to Defend Yourself',
    excerpt: 'Why hitting a paper target on a calm range is not the same skill as defending your life — and how to train the difference.',
    date: '2026-10-08',
    category: 'Training',
    readTime: '6 min read',
    image: IMAGES.students,
    body: [
      'There is a big difference in learning how to shoot a gun vs. learning how to use a gun for self-defense. Target shooting rewards slow, precise shots in a controlled setting. A defensive encounter is fast, chaotic and stressful.',
      'Defensive training teaches you to recognize threats, make decisions under pressure and deliver combat-accurate shots when it matters. That is why every HPP course is built around real-world application rather than range-day fun.',
      'If you are new, start with Introduction to Defensive Handgun. If you already carry, Fundamentals of Concealed Carry and Intuitive Defensive Shooting are the logical next steps.',
    ],
  },
  {
    slug: 'nevada-ccw-checklist',
    title: 'Your Nevada CCW Checklist',
    excerpt: 'Everything to prepare before class day, from ID to ammunition, so qualification goes smoothly.',
    date: '2026-09-22',
    category: 'CCW',
    readTime: '4 min read',
    image: IMAGES.classroom,
    body: [
      'Bring a valid government-issued ID, your handgun or plan to rent one, the ammunition listed on your confirmation, eye and ear protection, water and a pen.',
      'After class, you will apply with your county sheriff. Non-residents can apply with any Nevada county sheriff.',
      'Remember: Nevada is not a constitutional carry state, and out-of-state, military or law-enforcement training does not qualify on its own.',
    ],
  },
  {
    slug: 'women-only-classes',
    title: 'Why Women-Only Classes Work',
    excerpt: 'CCW Maggie on starting women-only classes in 2013 and what changes when the room changes.',
    date: '2026-09-04',
    category: "Women's Training",
    readTime: '5 min read',
    image: IMAGES.women,
    body: [
      'In 2013 Maggie began offering women-only classes taught by women. The goal was simple: an environment where every student feels comfortable asking questions.',
      'Students consistently tell us they learn faster and leave more confident. Today the Women’s Defense Network continues that work with monthly clinics.',
    ],
  },
  {
    slug: 'home-defense-plan',
    title: 'Building a Home Defense Plan Your Family Understands',
    excerpt: 'Safe storage, safe rooms and simple communication — the parts of home defense that matter before a firearm does.',
    date: '2026-08-18',
    category: 'Home Defense',
    readTime: '7 min read',
    image: IMAGES.homeDefense,
    body: [
      'Home defense starts long before a firearm is involved. Layered security, lighting, locks and a family plan prevent most problems.',
      'Safe storage that still allows quick access is essential, especially with children in the home. Our FOHD course walks through practical options.',
    ],
  },
  {
    slug: 'low-light-reality',
    title: 'The Low Light Reality',
    excerpt: 'Most defensive encounters happen in reduced light. Here is how to prepare.',
    date: '2026-07-30',
    category: 'Training',
    readTime: '5 min read',
    image: IMAGES.lowlight,
    body: [
      'You must identify your target before you can respond. In low light, that requires a quality light and the skill to use it.',
      'Our Low Light Defensive Handgun course covers handheld and weapon-mounted techniques in realistic conditions.',
    ],
  },
  {
    slug: 'choosing-a-holster',
    title: 'Choosing a Holster You Will Actually Wear',
    excerpt: 'Comfort, retention and trigger coverage — what to look for in an everyday carry holster.',
    date: '2026-07-12',
    category: 'Concealed Carry',
    readTime: '4 min read',
    image: IMAGES.holster,
    body: [
      'A good holster covers the trigger guard completely, holds the gun securely and is comfortable enough to wear every day.',
      'Bring your holster to Fundamentals of Concealed Carry and we will help you evaluate it.',
    ],
  },
];
